import {Component, inject} from '@angular/core';
import {ModalService} from '@core/services';

export type PlanExpiredSessionAction = 'extend' | 'close' | 'dismiss';

@Component({
  selector: 'core-plan-expired-session',
  imports: [],
  templateUrl: './plan-expired-session.html',
  styleUrl: './plan-expired-session.scss',
  standalone: true,
  host: {
    style: 'width: 100%;display:flex;flex-direction:column;gap:0.75rem'
  }
})
export class PlanExpiredSession {
  private modal = inject(ModalService);

  choose(action: PlanExpiredSessionAction) {
    this.modal.closeTop<PlanExpiredSessionAction>(action);
  }
}
